import {Observable, Subscription} from 'rxjs';

import IUiEventsStreamPayload from '../../../../Ui/Shared/Interfaces/IUiEventsStreamPayload';
import ICaptionsStore         from '../Interfaces/ICaptionsStore';

const subscribeToCaptionsOptionTap = (
    captionButtonTap$: Observable<IUiEventsStreamPayload>,
    captionsStore: ICaptionsStore
): Subscription =>
    captionButtonTap$
        .subscribe(({eventData}) => captionsStore.actions.setActiveTrack(eventData.language));

export default subscribeToCaptionsOptionTap;